import RenderAfterNavermapsLoaded from 'utils/RenderAfterNavermapsLoaded';
import styled from 'styled-components';
import DropDown, { IDropDownOption } from 'components/Dropdown';
import { useEffect, useCallback } from 'react';
import { Message, sendReactNativeMessage } from 'utils/ReactNativeMessage';
import {
  setSidoList,
  setSigunguList,
  setSido,
  setSigungu,
} from 'redux/store/branchMapReducer';
import { RootState } from 'redux/store/rootReducer';
import { useDispatch, useSelector } from 'react-redux';
import clientAxios from 'api/clientAxios';
import BranchMap from './BranchMap';

const BranchMapHome = () => {
  const branchMapStore = useSelector(
    (state: RootState) => state.branchMapStore,
  );
  const dispatch = useDispatch();

  const getBranchListByRegion = useCallback(
    async (sigunguCd: string) => {
      try {
        const { data } = await clientAxios.post(
          '/branch/api/region',
          {},
          {
            params: { sigunguCd },
          },
        );
        const msg: Message = {
          type: 'branchList',
          payload: data.data,
        };
        sendReactNativeMessage(msg);
      } catch (error) {
        console.log(error);
      }
    },
    [branchMapStore.sigunguList],
  );

  const getSigunguList = useCallback(
    async (sidoCd: string) => {
      try {
        const { data } = await clientAxios.get(
          '/api/intermediary/area/sigunguList',
          {
            params: { sidoCd },
          },
        );
        const sigunguList = data.data.map((item) => {
          return { value: item.sigunguCd, label: item.sigunguNm };
        });
        dispatch(setSigunguList(sigunguList));
      } catch (error) {
        console.log(error);
      }
    },
    [branchMapStore.sido],
  );

  const handleSelectSigungu = (option: IDropDownOption) => {
    dispatch(setSigungu(option.label));
    getBranchListByRegion(option.value);
  };

  const handleSelectSido = async (option: IDropDownOption) => {
    dispatch(setSigungu(''));
    dispatch(setSido(option.label));

    // 앱 리스트에도 전체지점 전달
    if (option.value === 'all') {
      try {
        const { data } = await clientAxios.get('/branch/list');
        const msg: Message = {
          type: 'branchList',
          payload: data.data,
        };

        sendReactNativeMessage(msg);
        dispatch(setSigunguList([]));
      } catch (error) {
        console.log(error);
      }
    } else {
      getSigunguList(option.value);
    }
  };

  useEffect(() => {
    const getSidoList = async () => {
      try {
        const sidoList = await clientAxios.get('/api/district/sidoList');
        const data = sidoList.data.data.map((item) => {
          return { value: item.sigunguCd, label: item.sidoNm };
        });
        data.unshift({ value: 'all', label: '전체' });
        dispatch(setSidoList(data));
      } catch (error) {
        console.log(error);
      }
    };
    getSidoList();
  }, []);

  return (
    <>
      <Container>
        <MenuContainer>
          <DropDown
            defaultText="광역시/도"
            options={branchMapStore.sidoList}
            selected={branchMapStore.sido}
            onSelect={handleSelectSido}
          />
          <DropDown
            defaultText="시/군/구"
            options={branchMapStore.sigunguList}
            selected={branchMapStore.sigungu}
            onSelect={handleSelectSigungu}
          />
        </MenuContainer>

        <RenderAfterNavermapsLoaded
          ncpClientId={`${process.env.REACT_APP_NAVER_MAP_KEY}`}
          error={
            <LoadingContainer>
              <img src="/images/loader.gif" alt="loading" />
            </LoadingContainer>
          }
          loading={
            <LoadingContainer>
              <img src="/images/loader.gif" alt="loading" />
            </LoadingContainer>
          }
        >
          <BranchMap width="100%" height="100%" zoom={14} />
        </RenderAfterNavermapsLoaded>
      </Container>
    </>
  );
};

export default BranchMapHome;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;
const MenuContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  position: absolute;
  z-index: 2;
  padding-top: 16px;
`;
